import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import mime from 'mime-types';
import Step15View from './Step15-view';
import {checkRequiredValues} from '../../utils/forms/checkRequiredValues';
import config from '../../config/common';
import {fileTypesIds} from '../../constants/fileTypeIds';
import types from '../../types';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {errors as E} from '../../constants/errors';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const ALLOWED_FILE_TYPES = [
  'pdf',
  'jpg',
  'jpeg',
  'png',
  'bmp',
  'gif',
  'ttf',
  'tiff'
];

const errWrongType = 'wrong file type';

const Step15 = ({
                  submitStep,
                  uploadFile,
                  showGlobalErrorMessage,
                  regType
                }) => {
  const initialValues = {
    pdf: null,
  };

  const validate = values => {
    let errors = {};
    errors = checkRequiredValues(values, errors);

    return errors;
  };

  const validateFileType = (form, field, setFileUploaded) => files => {
    const [file] = files;
    const fileType = mime.extension(file.type);
    const fileNotAllowed = ALLOWED_FILE_TYPES.indexOf(fileType) < 0;
    if (fileNotAllowed) {
      showGlobalErrorMessage(E.STEP_15_WRONG_FILE);
      form.setFieldValue(field.name, null);
      setFileUploaded(false)
    }
  };

  const {formatMessage} = useIntl();

  const handleSubmit = values => {
    Promise.resolve()
      .then(() => submitFiles(values))
      .then(() => submitFields())
      .then(checkNextStepAndGo)
      .then(() => trackEvent('signup_step',
          {
            step_number: 15,
            step_name_en: 'Income tax',
            step_name_he: formatMessage({id: 'step15.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => {
        if (err.message === errWrongType) {
          showGlobalErrorMessage(E.STEP_15_WRONG_FILE);
        }
      });
  };

  const submitFiles = values => {
    const file = values.pdf[0];
    const fileType = mime.extension(file.type);
    const fileNotAllowed = ALLOWED_FILE_TYPES.indexOf(fileType) < 0;
    if (fileNotAllowed) {
      throw new Error(errWrongType)
    }

    return uploadFile({
      file,
      fileTypeId: fileTypesIds.step15.taxAdjustmentPDF
    })
  };

  const submitFields = () => {
    return submitStep({
      step: 15,
      data: {regType},
    })
  };

  const submitFieldsOnly = () => {
    submitFields()
      .then(checkNextStepAndGo)
      .catch(err => console.log({err}));
  };

  const copyNumber = () => {
    try {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(config.deductionFileNumber)
          .catch(err => console.error(err));
      } else {
        // clipboard polyfill for mobile browsers
        window.Clipboard = (function (window, document, navigator) {
          let textArea,
            copy;

          function isOS() {
            return navigator.userAgent.match(/ipad|iphone/i);
          }

          function createTextArea(text) {
            textArea = document.createElement('textArea');
            textArea.value = text;
            document.body.appendChild(textArea);
          }

          function selectText() {
            let range,
              selection;

            if (isOS()) {
              range = document.createRange();
              range.selectNodeContents(textArea);
              selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
              textArea.setSelectionRange(0, 999999);
            } else {
              textArea.select();
            }
          }

          function copyToClipboard() {
            document.execCommand('copy');
            document.body.removeChild(textArea);
          }

          copy = function (text) {
            createTextArea(text);
            selectText();
            copyToClipboard();
          };

          return {
            copy: copy
          };
        })(window, document, navigator);

        window.Clipboard.copy(config.deductionFileNumber);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const allowedFiles = ALLOWED_FILE_TYPES.map(type => `.${type}`).join(', ');

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({isValid, submitCount}) => (
        <Step15View
          copyNumber={copyNumber}
          onOutlineBtnClick={submitFieldsOnly}
          isValid={isValid || submitCount === 0}
          fileTypes={allowedFiles}
          onChange={validateFileType}
        />
      )}
    </Formik>
  )
};

Step15.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  submitStep: PropTypes.func,
  showGlobalErrorMessage: PropTypes.func,
  uploadFile: PropTypes.func
};

export default Step15;
